import { useEffect, useState } from 'react';
import { createRoute, stripSearchParams } from '@tanstack/react-router';

import { rootRoute, useAppRouterInitial } from '../routerBase';
import {
  SCHEDULER_SEARCH_DEFAULTS,
  parseSchedulerSearch,
} from '../../hooks/useSchedulerRouterSearch';
import { TableViewSkeleton } from '../../components/Skeleton/TableViewSkeleton';
import { useTranslation } from '../../hooks/useTranslation';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
// Type-only import so the per-route bundle stays split — the runtime module
// is loaded via dynamic import() inside the route's effect (see below).
import type Scheduler from '../../components/Scheduler/index';

export const schedulerIndexRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/scheduler',
  validateSearch: parseSchedulerSearch,
  search: { middlewares: [stripSearchParams(SCHEDULER_SEARCH_DEFAULTS)] },
  component: function SchedulerIndexRoute() {
    const { t } = useTranslation();
    const { currentUser } = useAppRouterInitial();
    useDocumentTitle(t('common.page_titles.scheduler'));
    const [Component, setComponent] = useState<typeof Scheduler | null>(null);
    useEffect(() => {
      import('../../components/Scheduler/index').then((mod) => {
        setComponent(() => mod.default);
      });
    }, []);
    if (!Component) {
      return <TableViewSkeleton label={t('common.loading')} />;
    }
    return <Component currentUser={currentUser} />;
  },
});
